import { render, staticRenderFns } from "./tweets.vue?vue&type=template&id=fb5a988a&scoped=true&lang=pug&"
import script from "./tweets.vue?vue&type=script&lang=js&"
export * from "./tweets.vue?vue&type=script&lang=js&"
import style0 from "./tweets.vue?vue&type=style&index=0&id=fb5a988a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5a988a",
  null
  
)

export default component.exports